module.exports = __webpack_public_path__ + "img/RedBetwixt.a6f5ad50.png";